import { render, staticRenderFns } from "./lookassociate.vue?vue&type=template&id=1087848b"
import script from "./lookassociate.vue?vue&type=script&lang=js"
export * from "./lookassociate.vue?vue&type=script&lang=js"
import style0 from "./lookassociate.vue?vue&type=style&index=0&id=1087848b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports